module.exports = __webpack_public_path__ + "img/rap.57465a34.svg";